export var buildEnv = {
  buildMode: 'release',
  sdkVersion: '3.11.0'
};